import React from 'react';

interface StatsCard2Props {
  className?: string;
  targetCustomerCount?: number;
  actualCustomerCount?: number;
  householdpercentage?: number;
  redirectLink?: string;
}

export default function StatsCard2({
  className,
  targetCustomerCount,
  actualCustomerCount,
  householdpercentage,
  redirectLink
}: StatsCard2Props) {

  console.log('StatsCard2 props:', {
    targetCustomerCount,
    actualCustomerCount,
    householdpercentage
  });

  const percentage = householdpercentage ?? 0;

  return (
    <div className={`bg-white-100 flex gap-8 ${className || ''}`}>
      {/* HOUSEHOLD CARD */}
      <div className="flex-1 rounded-3xl overflow-hidden" style={{ backgroundColor: '#f4b7f9', display: 'flex', flexDirection: "column", justifyContent: "space-between" }}>
        {/* Top Section - Main Stats */}
        <div
          className="px-8 py-6 relative"
          style={{
            backgroundColor: '#f4b7f9',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* Icon */}
          {/* <div className="mb-6 flex justify-start">
            <img
              src="/icons8-test-account-60.png"
              alt="Account"
              style={{ width: '48px', height: '48px' }}
            />
          </div> */}

          {/* Main Stats */}
          <div className="flex items-center gap-4 mb-4">
            <span className="text-6xl font-bold text-black leading-none">
              {targetCustomerCount ?? 'N/A'}
            </span>
            <div className="flex flex-col gap-0">
              <a href={redirectLink ? `/${redirectLink}` : "#"} className='text-dark text-hover-primary fw-bold fs-3'>Households connected</a>
            </div>
          </div>

          {/* Progress Bar */}

        </div>

        <div className="px-8 py-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-bold text-black">Active</span>
            <span className="text-sm font-bold text-black">
              {percentage.toFixed(1)}%
            </span>
          </div>
          <div style={{
            height: '16px',
            backgroundColor: '#ffffff',
            borderRadius: '20px',
            overflow: 'hidden',
            border: '2px solid #000000',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
          }}>
            <div style={{
              height: '100%',
              width: `${Math.min(percentage, 100)}%`,
              backgroundColor: '#e795ce',
              borderRadius: '18px',
              transition: 'width 0.3s ease'
            }} />
          </div>
        </div>

        {/* Bottom Section */}
        <div
          className="px-8 py-4"
          style={{
            backgroundColor: 'rgba(201, 69, 105, 0.3)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundBlendMode: 'multiply',
          }}
        >
          <div className="flex flex-col gap-1">
            <span className="text-5xl font-bold text-black leading-none">
              {actualCustomerCount ?? 'N/A'}
            </span>
            <span className='text-dark text-hover-primary fw-bold fs-3'>Active households</span>
          </div>
        </div>
      </div>
    </div>
  );
}